import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { DocumentTextIcon } from '../../../../components/ui/Icons';

const EmptyState = () => {
  const { theme } = useTheme();

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center max-w-sm">
        <div className={cn("w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4", theme.colors.surface)}>
          <DocumentTextIcon className={cn("h-8 w-8", theme.text.secondary)} />
        </div>
        <h3 className={cn("text-lg font-semibold mb-2", theme.text.primary)}>No Approval Selected</h3>
        <p className={cn("text-sm leading-relaxed", theme.text.secondary)}>
          Select an approval from the list to view details, track progress, and take actions.
        </p>
      </div>
    </div>
  );
};

export default EmptyState;
